const TTL_MS = 30 * 1000; // auctions change quickly → short TTL

export function getFresh(state) {
  // ctx is an optional string that encodes user/license/company context
  return (id, ctx = "") => {
    const e = state.byId[id];
    if (!e) return null;
    const fresh = Date.now() - e.ts < TTL_MS;
    if (!fresh) return null;
    if (e.ctx !== ctx) return null; // context-aware
    return e.item;
  };
}

export function getStale(state) {
  return (id) => state.byId[id]?.item || null;
}
